var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){return _vm.toCSV()}}},[_vm._v("Export")]),_c('ProjectResult',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }